<ng-container>
    <button class="partner-card" role="region" aria-label="View details about partner-title-{{partner.id}}"
    (click)="openPartnerDetailPage($event)" (keypress)="openPartnerDetailPage($event)">
        <div class="partner-image-container">
            <div class="partner-image" role="img" aria-label="Image of {{ partner.title }}"></div>
        </div>
        <div class="partner-detail-container">
            <div id="partner-title-{{partner.id}}" class="partner-title" aria-label="{{ partner.title }}">
                {{ partner.title }}
            </div>
            <div class="partner-subtitle mt-2" aria-label="{{ partner.subTitle }}">
                {{ partner.subTitle }}
            </div>
            <div class="button-container">
                <div class="button-display" aria-label="{{ partner.ctaText }}">
                    {{ partner.ctaText }}
                </div>
            </div>
        </div>
    </button>
</ng-container>

